@if (rs(); as r) {
  <app-section-quick-actions section="spirit" />

  <header class="atmos-page__header">
    <h1 class="atmos-page__title">{{ r.name }}</h1>
  </header>

  @if (r.draft) {
    <app-draft-warning />
  }

  <section class="atmos-card atmos-rs-detail__summary">
    <div class="atmos-card__body">
      <div class="atmos-facts">
        <div class="atmos-fact">
          <div class="atmos-fact__label">Dates</div>
          <div class="atmos-fact__value atmos-fact__value--wrap" [class.is-ended]="state() === 'ended'">
            <mat-icon class="atmos-fact__icon">calendar_month</mat-icon>
            <span><app-date-range [start]="r.date" [end]="r.endDate"></app-date-range></span>
            @if (state() === 'future') {
              <span class="atmos-pill">
                <app-days-left [start]="r.date" [end]="r.endDate"></app-days-left>
              </span>
            }
          </div>
        </div>

        <div class="atmos-fact">
          <div class="atmos-fact__label">Duration</div>
          <div class="atmos-fact__value atmos-fact__value--wrap" [class.is-ended]="state() === 'ended'">
            <mat-icon class="atmos-fact__icon">schedule</mat-icon>
            <span><app-duration [start]="r.date" [end]="r.endDate"></app-duration></span>
            @if (state() === 'active') {
              <span class="atmos-pill atmos-pill--active">
                <app-days-left [start]="r.date" [end]="r.endDate"></app-days-left>
              </span>
            }
          </div>
        </div>

        @if (r.area?.realm) {
          <div class="atmos-fact">
            <div class="atmos-fact__label">Realm</div>
            <a class="atmos-fact__value" [routerLink]="['/realm', r.area!.realm!.guid]">
              <mat-icon class="atmos-fact__icon">map</mat-icon>
              <span class="atmos-fact__text">{{ r.area!.realm!.name }}</span>
            </a>
          </div>
        }

        @if (r.area) {
          <div class="atmos-fact">
            <div class="atmos-fact__label">Area</div>
            <div class="atmos-fact__value">
              <mat-icon class="atmos-fact__icon">location_on</mat-icon>
              <span class="atmos-fact__text">{{ r.area.name }}</span>
            </div>
          </div>
        }
      </div>
    </div>

    @if (r._wiki || r._calendar) {
      <div class="atmos-summary__actions">
        @if (r._wiki) {
          <app-wiki-link [wiki]="r._wiki" aClass="atmos-summary__action"></app-wiki-link>
        }
        @if (r._calendar) {
          <app-calendar-link [cal]="r._calendar" aClass="atmos-summary__action"></app-calendar-link>
        }
      </div>
    }
  </section>

  <section class="atmos-card atmos-rs-detail__trees-card">
    <div class="atmos-card__body atmos-rs-detail__trees-body">
      <h2 class="atmos-rs-detail__trees-title">Spirits</h2>
      <div class="atmos-spirit-trees atmos-rs-detail__trees-scroll">
        @for (spirit of r.spirits; track spirit.tree.guid) {
          @if (spirit.tree) {
            <div class="atmos-rs-detail__tree">
              <app-spirit-tree
                [tree]="spirit.tree"
                [name]="spirit.spirit.name"
                [nameLink]="['/spirit', spirit.spirit.guid]"
                [nameQueryParams]="{ highlightTree: spirit.tree.guid }">
              </app-spirit-tree>
            </div>
          }
        }
      </div>
    </div>
  </section>
}
